'use client'

import { useRouter } from 'next/navigation'

import { useAuthContext } from '@/context/AuthContext'
import { useConfigsContext } from '@/context/ConfigsContext'
import { getCreateDomain } from '@/lib/configs'

export function usePartnerApply() {
  const router = useRouter()
  const { handleLogin } = useAuthContext()
  const { store } = useConfigsContext()

  function handleClickApplyButton() {
    const callbackUrl = `https://${getCreateDomain()}/partner-application`

    if (store?.credentials?.htcToken) {
      router.push(callbackUrl)
    } else {
      handleLogin({ callback: callbackUrl })
    }
  }

  return { handleClickApplyButton }
}
